import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/types";

/**
 * Custom props for the form control
 */
interface Props {
    /**
     * Label text
     */
    labelText: string;
    /**
     * tooltip icon
     */
    tooltipIcon?: IconProp;
    /**
     * Tooltip text
     */
    tooltipText?: string | ReactNode;
    /**
     * Col span
     */
    colSpan?: number;
    /**
     * where the tooltip should be placed
     */
    tooltipPlacement?: Placement;
    /**
     * The form state 
     */
    formState: string;
    /**
     * on form change callback function
     */
    onChange: (value: string) => void;
    /**s
     * The form placeholder text
     */
    formPlaceholder: string;
    /**
     * Form read only state
     */
    isReadOnly: boolean;
    /**
     * Container custom class
     */
    containerCustomClass?: string;
    /**
     * the max length of the input 
     */
    maxLength?: number;
}

/**
 * A custom form control 
 */
export const CustomFormControl = ({
    colSpan = 12,
    labelText,
    tooltipIcon,
    tooltipPlacement = "right",
    tooltipText,
    formState,
    formPlaceholder = "",
    isReadOnly = false,
    containerCustomClass,
    maxLength,
    onChange,
}: Props) => {

    /**
     * Function that handles the change event
     */
    const handleChange = (value: string) => onChange(value);
    return (
        <Col xs={colSpan} className={containerCustomClass}>
            <Form.Label>
                <strong>{labelText}</strong>
                {tooltipIcon &&
                    <OverlayTrigger
                        trigger={["hover", "focus"]}
                        placement={tooltipPlacement}
                        overlay={
                            <Tooltip className="custom-tooltip text-unwrap">
                                {tooltipText}
                            </Tooltip>
                        }
                    >
                        <FontAwesomeIcon icon={tooltipIcon} className="ms-2" />
                    </OverlayTrigger>
                }
            </Form.Label>
            <Form.Control
                maxLength={maxLength}
                type="text"
                onChange={(e) => handleChange(e.target.value)}
                value={formState}
                readOnly={isReadOnly}
                placeholder={formPlaceholder}
            />
        </Col>
    )
}
